import type { TOptions, TParams } from './models';

interface IGetFormatOptions {
    body?: TParams;
    isFormData: boolean;
    options?: TOptions;
}

export const checkIsFormData = (body: TParams): boolean =>
    typeof window !== 'undefined' && body instanceof FormData;

export const getFormatOptions = ({
    isFormData,
    options: { headers, ...options } = {},
    body,
}: IGetFormatOptions): TOptions => {
    const formatOptions: {
        body?: TParams;
        credentials?: TOptions['credentials'];
        headers: TOptions['headers'];
    } = {
        headers: {
            Accept: 'application/json',
            ...(!isFormData && body && { 'Content-Type': 'application/json' }),
            ...(isFormData && body && { 'Content-Type': 'multipart/form-data' }),
            ...headers,
        },

        ...options,
    };

    if (body === null) return formatOptions;

    formatOptions.body = isFormData || typeof body === 'string' ? body : JSON.stringify(body);

    return formatOptions;
};

export const isHeaders = (headers: TOptions['headers']): headers is Headers =>
    headers?.constructor?.name === 'Headers';

export const getFormatHeaders = (headers: TOptions['headers']) => {
    if (Array.isArray(headers)) return Object.fromEntries(headers);
    if (isHeaders(headers)) return Object.fromEntries(headers.entries());

    return headers || {};
};
